import { getCurrentInstance, ref } from 'vue';
import { nanoid } from 'nanoid';

export default function useReconnectionCallbacks() {
  const _this = getCurrentInstance();
  const proxy: any = _this?.proxy;
  const reconnectionCallbacksIds = ref<Array<string>>([]);

  const addCallbackId = (callbackId: string) => {
    reconnectionCallbacksIds.value.push(callbackId);
  };

  const addReconnectionCallback = (callback: Function) => {
    const callbackId = nanoid(10);
    addCallbackId(callbackId);
    proxy.$store.dispatch('addReconnectionCallback', {
      callbackId,
      callback,
    });
  };

  const removeReconnectionCallbacks = () => {
    for (const callbackId of reconnectionCallbacksIds.value) {
      proxy.$store.dispatch('removeReconnectionCallback', callbackId);
    }
  };

  return {
    reconnectionCallbacksIds,
    addReconnectionCallback,
    removeReconnectionCallbacks,
  };
}
